import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, OperatorFunction } from 'rxjs';

// services
import { Utils } from '../../services/utils.service';

export enum AdditionalParams {
	AsSingleFile = 'as_single_file',
	GroupByPlans = 'group_by_plans',
	SkipImages = 'skip_images',
	AlbumView = 'landscape',
	ExcludeMasterPositions = 'exclude_mp_relations'
}

export interface IInputEquipmentsModalData {
	count?: number;
	params?: any;
	downloadMethod: (params: any) => Observable<void>;
    pipeMethod?: OperatorFunction<any, any>,
	additionalParams?: Array<IAdditionalParam>;
}

interface IAdditionalParam {
	param: AdditionalParams;
	title: string;
	type: 'toggle' | 'icons';
	icons?: [{ icon: string; title?: string }, { icon: string; title?: string }];
	info?: string;
}

type AdditionalFormParams = {
	[key in AdditionalParams]: FormControl<boolean>;
}

interface IFormParams extends Partial<AdditionalFormParams> {
	equipment_format: FormControl<FileFormat>;
}

type AdditionalRequestParams = {
	[key in AdditionalParams]: boolean;
}

interface IRequestParams extends Partial<AdditionalRequestParams> {
	equipment_format: FileFormat;
}

export interface IMultiEquipmentsModalResult extends Partial<AdditionalRequestParams> {
	format: FileFormat;
	count: number;
}

export type FileFormat = 'pdf' | 'excel'

@Component({
    selector: 'app-equipments-download-modal',
    templateUrl: './equipments-download-modal.component.html',
    styleUrls: ['./equipments-download.component.scss'],
    standalone: false
})
export class EquipmentsDownloadModalComponent implements OnInit {

	inputData: IInputEquipmentsModalData;
	formGroup: FormGroup<IFormParams>;

	constructor(
		private dialogRef: MatDialogRef<EquipmentsDownloadModalComponent>,
		@Inject(MAT_DIALOG_DATA) private data: IInputEquipmentsModalData
	) {}

	ngOnInit(): void {
		this.inputData = this.data;
		this.formGroup = new FormGroup<IFormParams>({
			equipment_format: new FormControl<FileFormat>(null)
		});

		this.inputData?.additionalParams?.forEach((param: IAdditionalParam) => {
			this.formGroup.addControl(param.param, new FormControl<boolean>(false));
		});
	}

	setActiveFormat(format: FileFormat): void {
		this.formGroup.controls.equipment_format.setValue(format);
	}

	download(): void {
		if (!this.formGroup.controls.equipment_format.value) return;
		
		if (this.inputData.downloadMethod) {
			const params: IRequestParams = {
				equipment_format: this.formGroup.controls.equipment_format.value
			}
			this.inputData?.additionalParams?.forEach((param: IAdditionalParam) => {
				params[param.param] = this.formGroup.get(param.param).value;
			});
			Utils.assignObject(params, this.inputData.params);

            let request$: Observable<void> = this.inputData.downloadMethod(params);
            if (this.inputData.pipeMethod) {
                request$ = request$.pipe(this.inputData.pipeMethod);
            }
            request$.subscribe();
		}
		this.close(true);
	}

	close(isDownload: boolean = false): void {
		let result: IMultiEquipmentsModalResult | null = null;
		if (isDownload) {
			result = {
				format: this.formGroup.controls.equipment_format.value,
				count: this.inputData.count
			}
			this.inputData?.additionalParams?.forEach((param: IAdditionalParam) => {
				result[param.param] = this.formGroup.get(param.param).value;
			});
		}
		this.dialogRef.close(result);
	}
}
